"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const trans_1 = require("@common/tsutils/trans");
let BoxPlotNavigation = class BoxPlotNavigation extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.stages = [
            {
                id: 'clusters',
                icon: 'icon_cluster_building',
                name: (0, trans_1.trans)('toolkit.metrics_boxplot.navig.cb'),
                disabledConditions: []
            },
            {
                id: 'ranking',
                icon: 'icon_variation_ranking',
                name: (0, trans_1.trans)('toolkit.metrics_boxplot.navig.vr'),
                disabledConditions: ['clusters']
            },
            {
                id: 'boxplot',
                icon: 'icon_index_boxplot',
                name: (0, trans_1.trans)('toolkit.metrics_boxplot.navig.ip'),
                disabledConditions: ['clusters', 'ranking']
            }
        ];
    }
    jumpStage(id) {
        this.$emit('switchStage', id);
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: 'clusters' })
], BoxPlotNavigation.prototype, "stage", void 0);
BoxPlotNavigation = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {}
    })
], BoxPlotNavigation);
exports.default = BoxPlotNavigation;
